export const DEFAULT_FAVICON_PATH = '/RMLogo.png';

export const FAVICON_MAP: Record<string, string> = {
  exp: '/SvgIcons/Experiment.svg',
  protein: '/SvgIcons/ProteinFormulation.svg',
  screen: '/SvgIcons/Screen.svg',
  snf: '/SvgIcons/SearchAndFilterIcon.svg',
  fragment: '/SvgIcons/Fragment/Fragment.svg',
  seed: '/SvgIcons/Seed.svg',
  synchrotrontrip: '/SvgIcons/SynchrotronTrip.svg',
  search: '/SvgIcons/Search.svg',
};

export const PROTEIN_FAVICON_PATH = FAVICON_MAP.protein;
export const PROTEIN_VARIANTS_FAVICON_PATH = '/SvgIcons/ProteinFormulation_Variants.svg';

export const setAppFavicon = (iconPath: string): void => {
  const appBaseUrl = process.env.PUBLIC_URL || '';
  const iconHref = `${appBaseUrl}${iconPath}`;
  let faviconLink = document.getElementById('app-favicon') as HTMLLinkElement | null;

  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.id = 'app-favicon';
    faviconLink.rel = 'shortcut icon';
    document.head.appendChild(faviconLink);
  }

  faviconLink.type = 'image/svg+xml';
  faviconLink.href = iconHref;
};

export const getFaviconPathForRoute = (routeKey: string): string =>
  FAVICON_MAP[routeKey] || DEFAULT_FAVICON_PATH;
